import { styled, keyframes, CSS } from '../../../theme/stitches.config';
import { SMPFlex } from './SMPFlex';

const spinner = keyframes({
  to: {
    transform: 'rotate(360deg)',
  },
});

const LoadingSpinner = styled('div', {
  width: '10px',
  height: '10px',
  borderWidth: 2,
  borderStyle: 'solid',
  borderColor: 'white',
  borderRadius: '$radii$round',
  animation: `${spinner}  0.6s linear infinite`,
  variants: {
    color: {
      spinner: {
        borderTopColor: '$pillActiveBackgroundColor',
      },
    },
    size: {
      '1': {
        size: '$2',
        height: '$2',
      },
      '2': {
        width: '$4',
        height: '$4',
      },
      '3': {
        width: '$6',
        height: '$6',
      },
      '4': {
        width: '$8',
        height: '$8',
      },
    },
    thickness: {
      '1': {
        borderWidth: 2,
      },
      '2': {
        borderWidth: 4,
      },
      '3': {
        borderWidth: 6,
      },
      '4': {
        borderWidth: 8,
      },
    },
  },
});

type SMPLoaderProps = {
  color: 'spinner';
  size: 1 | 2 | 3 | 4;
  thickness: 1 | 2 | 3 | 4;
  css?: CSS;
  loaderMinHeight: string;
};

export const SMPLoader = (props: SMPLoaderProps) => {
  const { loaderMinHeight: minHeight, ...rest } = props;

  return (
    <SMPFlex justify='center' align='center' css={{ minHeight }}>
      <LoadingSpinner {...rest} />
    </SMPFlex>
  );
};
